import { useState, type ReactNode, type Ref } from 'react'
import styles from './OCRScopingJobs.module.css'
import { SplitView, SplitViewMain, SplitViewSide } from '@/components/SplitView'
import { SplitViewToggleButton } from '@/components/SplitView/SplitViewToggleButton'
import { Icon } from '@/components/Icon'
import { type DropzoneProps } from '@/hooks/dropzone-hook'
import { useHoverState } from '@/hooks/element-hooks'
import { CreateOCRScopeJobsDialogDraggingOverlay } from '@/features/jobs/scoping/components/CreateOCRScopeJobsDialog'

export interface OCRScopingJobsContentProps {
  dropzoneProps: DropzoneProps<HTMLDivElement>
  dragging: boolean
  sidePanelVisible: boolean
  onToggleSidePanel: () => unknown
  sidePanel: ReactNode
  mainPanel: ReactNode
  createDialog: ReactNode
}

export function OCRScopingJobsContent({
  dropzoneProps,
  dragging,
  sidePanelVisible,
  onToggleSidePanel,
  sidePanel,
  mainPanel,
  createDialog,
}: OCRScopingJobsContentProps) {
  const [highlightBorder, setHighlightBorder] = useState(false)
  const { isHovering: isToggleHovering } = useHoverState(setHighlightBorder)

  return (
    <div className={styles.root} {...dropzoneProps}>
      {dragging && <CreateOCRScopeJobsDialogDraggingOverlay />}
      <SplitView>
        <SplitViewSide
          collapsed={!sidePanelVisible}
          highlightBorder={highlightBorder}
        >
          {sidePanel}
        </SplitViewSide>

        <SplitViewMain>
          <div className={styles.toggleButtonContainer}>
            <OCRSplitViewToggleButton
              onNavSidebarToggle={onToggleSidePanel}
              isNavSidebarVisible={sidePanelVisible}
              isToggleHovering={isToggleHovering}
            />
          </div>
          {mainPanel}
        </SplitViewMain>
      </SplitView>
      {createDialog}
    </div>
  )
}

export interface OCRSplitViewToggleButtonProps {
  onNavSidebarToggle?: () => unknown
  isNavSidebarVisible: boolean
  isToggleHovering: boolean
  toggleRef?: Ref<HTMLButtonElement>
}

export function OCRSplitViewToggleButton({
  onNavSidebarToggle,
  isNavSidebarVisible,
  isToggleHovering,
  toggleRef,
}: OCRSplitViewToggleButtonProps) {
  if (onNavSidebarToggle) {
    return (
      <SplitViewToggleButton onPress={onNavSidebarToggle} ref={toggleRef}>
        {isToggleHovering ? (
          isNavSidebarVisible ? (
            <Icon name="hover-arrow-highlight" />
          ) : (
            <Icon name="hover-menu-highlight" />
          )
        ) : isNavSidebarVisible ? (
          <Icon name="hover-arrow" />
        ) : (
          <Icon name="hover-menu" />
        )}
      </SplitViewToggleButton>
    )
  }
  return null
}
